import cx from 'classnames';

export const CaretIcon = ({ className }: { className?: string }) => {
    return (
        <svg
            className={cx(
                'stroke-current absolute left-0 h-full w-full',
                className,
            )}
            viewBox="0 0 22 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="xMidYMid meet"
        >
            <path
                d="M2 1.49953L11 10.4995L20 1.49953"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
export const LibraryIcon = () => {
    return (
        <svg
            className="stroke-current absolute left-0 top-0  h-full w-full"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z"
            />
        </svg>
    );
};

export const PhoneIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className="stroke-current absolute left-0 top-0  h-full w-full"
            fill="none"
            viewBox="0 0 24 24"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
            />
        </svg>
    );
};

export const SlidersIcon = () => {
    return (
        <svg
            className="stroke-current absolute left-0 top-0  h-full w-full"
            viewBox="0 0 28 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="xMidYMid meet"
        >
            <path
                d="M1 3.25H7.75M7.75 3.25C7.75 4.49264 8.75736 5.5 10 5.5C11.2426 5.5 12.25 4.49264 12.25 3.25M7.75 3.25C7.75 2.00736 8.75736 1 10 1C11.2426 1 12.25 2.00736 12.25 3.25M1 12.25H16.75M16.75 12.25C16.75 13.4926 17.7574 14.5 19 14.5C20.2426 14.5 21.25 13.4926 21.25 12.25M16.75 12.25C16.75 11.0074 17.7574 10 19 10C20.2426 10 21.25 11.0074 21.25 12.25M1 21.25H4.75M4.75 21.25C4.75 22.4926 5.75736 23.5 7 23.5C8.24264 23.5 9.25 22.4926 9.25 21.25M4.75 21.25C4.75 20.0074 5.75736 19 7 19C8.24264 19 9.25 20.0074 9.25 21.25M12.25 3.25H26.5M21.25 12.25H26.5M9.25 21.25H26.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const HomeIcon = () => {
    return (
        <svg
            className="absolute left-0 top-0 stroke-current h-full w-full "
            viewBox="0 0 20 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="xMidYMid meet"
        >
            <path
                d="M1 8.24953L10 1.24953L19 8.24953V20.7495H13V14.7495H7V20.7495H1V8.24953Z"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const DocumentsIcon = () => {
    return (
        <svg
            className="stroke-current stroke-1.5 absolute left-0 top-0  h-full w-full"
            viewBox="0 0 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="xMidYMid meet"
        >
            <path
                d="M13.1031 6.49951C13.5173 6.49951 13.8531 6.16373 13.8531 5.74951C13.8531 5.3353 13.5173 4.99951 13.1031 4.99951H3.5C1.98122 4.99951 0.75 6.23073 0.75 7.74951V22.4996C0.75 24.0183 1.98122 25.2496 3.5 25.2496H18.25C19.7688 25.2496 21 24.0183 21 22.4996V14.0043C21 13.5901 20.6642 13.2543 20.25 13.2543C19.8358 13.2543 19.5 13.5901 19.5 14.0043V22.4996C19.5 23.1899 18.9404 23.7496 18.25 23.7496H3.5C2.80964 23.7496 2.25 23.1899 2.25 22.4996V7.74951C2.25 7.05916 2.80964 6.49951 3.5 6.49951H13.1031ZM9.79074 12.6057C9.67661 12.7218 9.60338 12.872 9.58211 13.0334L9.18569 16.0413C9.15624 16.2648 9.22885 16.4897 9.38344 16.6537C9.53802 16.8177 9.75818 16.9035 9.983 16.8874L13.1143 16.6624C13.2964 16.6494 13.4675 16.5703 13.5955 16.4401L24.5349 5.30817C24.8217 5.01637 24.8217 4.54859 24.5349 4.2568L21.8001 1.47382C21.6591 1.33034 21.4663 1.24951 21.2651 1.24951C21.064 1.24951 20.8712 1.33034 20.7302 1.47382L9.79074 12.6057Z"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const MessageBubbleIcon = () => {
    return (
        <svg
            className="stroke-current absolute left-0 top-0 h-full w-full"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="xMidYMid meet"
        >
            <path
                d="M21 12C21 16.4183 16.9706 20 12 20C10.7429 20 9.54603 19.7709 8.46852 19.3564L3 20L4.09477 16.7157C3.40393 15.3375 3 13.7238 3 12C3 7.58172 7.02944 4 12 4C16.9706 4 21 7.58172 21 12Z"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.8"
            />
        </svg>
    );
};

export const ScreenIcon = () => {
    return (
        <svg
            className="stroke-current absolute left-0 top-0 h-full w-full"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="xMidYMid meet"
        >
            <path
                d="M4 5.5H20V16.5H4V5.5Z"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.8"
            />
            <path
                d="M9 20H15"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.8"
            />
            <path
                d="M12 16.5V20"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.8"
            />
        </svg>
    );
};

export const PenIcon = () => {
    return (
        <svg
            className="stroke-current absolute left-0 top-0 h-full w-full"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="xMidYMid meet"
        >
            <path
                d="M4 20L8.5 19L19 8.5C19.8284 7.67157 19.8284 6.32843 19 5.5V5.5C18.1716 4.67157 16.8284 4.67157 16 5.5L5.5 16L4 20Z"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.8"
            />
            <path
                d="M14.5 7L17.5 10"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.8"
            />
        </svg>
    );
};

export const TrashIcon = () => {
    return (
        <svg
            className="stroke-current absolute left-0 top-0 h-full w-full"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="xMidYMid meet"
        >
            <path
                d="M4 7H20"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.8"
            />
            <path
                d="M9 7V5.5C9 4.67157 9.67157 4 10.5 4H13.5C14.3284 4 15 4.67157 15 5.5V7"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.8"
            />
            <path
                d="M18 7L17.4 17.2C17.3355 18.2962 16.4274 19.1527 15.3293 19.1527H8.6707C7.57262 19.1527 6.66448 18.2962 6.59998 17.2L6 7"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.8"
            />
            <path
                d="M10 10.5V15.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.8"
            />
            <path
                d="M14 10.5V15.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.8"
            />
        </svg>
    );
};
export const UsersIcon = () => {
    return (
        <svg
            className="stroke-current stroke-1.5 absolute left-0 top-0  h-full w-full"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="xMidYMid meet"
        >
            <path
                d="M7 13C8.65685 13 10 11.6569 10 10C10 8.34315 8.65685 7 7 7C5.34315 7 4 8.34315 4 10C4 11.6569 5.34315 13 7 13Z"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17 13C18.6569 13 20 11.6569 20 10C20 8.34315 18.6569 7 17 7C15.3431 7 14 8.34315 14 10C14 11.6569 15.3431 13 17 13Z"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M2 21C2 18.2386 4.23858 16 7 16H9C11.7614 16 14 18.2386 14 21"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10 21C10 18.2386 12.2386 16 15 16H17C19.7614 16 22 18.2386 22 21"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const LockIcon = () => {
    return (
        <svg
            className="stroke-current absolute left-0 top-0 h-full w-full"
            width="20"
            height="26"
            viewBox="0 0 20 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="xMidYMid meet"
        >
            <path
                d="M4 11.5V7C4 4.32812 5.2 1 10 1C14.8 1 16 4.32812 16 7V11.5M1 11.5H19V25H1V11.5Z"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const LogoutIcon = () => {
    return (
        <svg
            className="stroke-current absolute left-0 top-0 h-full w-full"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="xMidYMid meet"
        >
            <path
                d="M15 7V5C15 3.89543 14.1046 3 13 3H6C4.89543 3 4 3.89543 4 5V19C4 20.1046 4.89543 21 6 21H13C14.1046 21 15 20.1046 15 19V17"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10 12H21M21 12L18 9M21 12L18 15"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const EyeIcon = () => {
    return (
        <svg
            className="stroke-current absolute left-0 top-0 h-full w-full"
            width="20"
            height="15"
            viewBox="0 0 20 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="xMidYMid meet"
        >
            <path d="M1 7.6L0.561052 7.36057C0.479649 7.50981 0.479649 7.69019 0.561052 7.83943L1 7.6ZM19 7.6L19.4389 7.83943C19.5204 7.69019 19.5204 7.50981 19.4389 7.36057L19 7.6ZM1 7.6C1.43895 7.83943 1.43889 7.83954 1.43884 7.83962C1.43884 7.83962 1.43881 7.83968 1.43882 7.83967C1.43883 7.83965 1.43889 7.83953 1.43901 7.83931C1.43925 7.83888 1.43971 7.83805 1.44038 7.83683C1.44172 7.8344 1.44393 7.83041 1.447 7.82492C1.45313 7.81394 1.46269 7.79696 1.47563 7.77437C1.5015 7.72919 1.54086 7.66163 1.59324 7.57488C1.69806 7.40132 1.85482 7.15133 2.05999 6.85042C2.47095 6.24767 3.07281 5.44548 3.83668 4.64524C5.37892 3.02956 7.50562 1.5 10 1.5V0.5C7.09438 0.5 4.72108 2.27044 3.11332 3.95476C2.30219 4.80452 1.66655 5.65233 1.23376 6.28708C1.01705 6.60492 0.85038 6.87056 0.737225 7.05793C0.680629 7.15165 0.637365 7.22588 0.607869 7.27738C0.59312 7.30314 0.581808 7.32322 0.573988 7.33721C0.570078 7.34421 0.567041 7.34969 0.564882 7.3536C0.563803 7.35556 0.562944 7.35712 0.562305 7.35828C0.561986 7.35887 0.561722 7.35935 0.561513 7.35973C0.561409 7.35992 0.561293 7.36013 0.561241 7.36023C0.56114 7.36041 0.561052 7.36057 1 7.6ZM10 1.5C12.4944 1.5 14.6211 3.02956 16.1633 4.64524C16.9272 5.44548 17.529 6.24767 17.94 6.85042C18.1452 7.15133 18.3019 7.40132 18.4068 7.57488C18.4591 7.66163 18.4985 7.72919 18.5244 7.77437C18.5373 7.79696 18.5469 7.81394 18.553 7.82492C18.5561 7.83041 18.5583 7.8344 18.5596 7.83683C18.5603 7.83805 18.5608 7.83888 18.561 7.83931C18.5611 7.83953 18.5612 7.83965 18.5612 7.83967C18.5612 7.83968 18.5612 7.83962 18.5612 7.83962C18.5611 7.83954 18.5611 7.83943 19 7.6C19.4389 7.36057 19.4389 7.36041 19.4388 7.36023C19.4387 7.36013 19.4386 7.35992 19.4385 7.35973C19.4383 7.35935 19.438 7.35887 19.4377 7.35828C19.4371 7.35712 19.4362 7.35556 19.4351 7.3536C19.433 7.34969 19.4299 7.34421 19.426 7.33721C19.4182 7.32322 19.4069 7.30314 19.3921 7.27738C19.3626 7.22588 19.3194 7.15165 19.2628 7.05793C19.1496 6.87056 18.9829 6.60492 18.7662 6.28708C18.3335 5.65233 17.6978 4.80452 16.8867 3.95476C15.2789 2.27044 12.9056 0.5 10 0.5V1.5ZM19 7.6C18.5611 7.36057 18.5611 7.36046 18.5612 7.36038C18.5612 7.36038 18.5612 7.36032 18.5612 7.36033C18.5612 7.36035 18.5611 7.36047 18.561 7.36069C18.5608 7.36112 18.5603 7.36195 18.5596 7.36317C18.5583 7.3656 18.5561 7.36959 18.553 7.37508C18.5469 7.38606 18.5373 7.40304 18.5244 7.42563C18.4985 7.47081 18.4591 7.53837 18.4068 7.62512C18.3019 7.79868 18.1452 8.04867 17.94 8.34958C17.529 8.95233 16.9272 9.75452 16.1633 10.5548C14.6211 12.1704 12.4944 13.7 10 13.7V14.7C12.9056 14.7 15.2789 12.9296 16.8867 11.2452C17.6978 10.3955 18.3335 9.54767 18.7662 8.91292C18.9829 8.59508 19.1496 8.32944 19.2628 8.14207C19.3194 8.04835 19.3626 7.97412 19.3921 7.92261C19.4069 7.89686 19.4182 7.87678 19.426 7.86279C19.4299 7.85579 19.433 7.85031 19.4351 7.8464C19.4362 7.84444 19.4371 7.84288 19.4377 7.84172C19.438 7.84113 19.4383 7.84065 19.4385 7.84027C19.4386 7.84008 19.4387 7.83987 19.4388 7.83977C19.4389 7.83959 19.4389 7.83943 19 7.6ZM10 13.7C7.50562 13.7 5.37892 12.1704 3.83668 10.5548C3.07281 9.75452 2.47095 8.95233 2.05999 8.34958C1.85482 8.04867 1.69806 7.79868 1.59324 7.62512C1.54086 7.53837 1.5015 7.47081 1.47563 7.42563C1.46269 7.40304 1.45313 7.38606 1.447 7.37508C1.44393 7.36959 1.44172 7.3656 1.44038 7.36317C1.43971 7.36195 1.43925 7.36112 1.43901 7.36069C1.43889 7.36047 1.43883 7.36035 1.43882 7.36033C1.43881 7.36032 1.43884 7.36038 1.43884 7.36038C1.43889 7.36046 1.43895 7.36057 1 7.6C0.561052 7.83943 0.56114 7.83959 0.561241 7.83977C0.561293 7.83987 0.561409 7.84008 0.561513 7.84027C0.561722 7.84065 0.561986 7.84113 0.562305 7.84172C0.562944 7.84288 0.563803 7.84444 0.564882 7.8464C0.567041 7.85031 0.570078 7.85579 0.573988 7.86279C0.581808 7.87678 0.59312 7.89686 0.607869 7.92261C0.637365 7.97412 0.680629 8.04835 0.737225 8.14207C0.85038 8.32944 1.01705 8.59508 1.23376 8.91292C1.66655 9.54767 2.30219 10.3955 3.11332 11.2452C4.72108 12.9296 7.09438 14.7 10 14.7V13.7ZM12.5 7.6C12.5 8.98071 11.3807 10.1 10 10.1V11.1C11.933 11.1 13.5 9.533 13.5 7.6H12.5ZM10 10.1C8.61929 10.1 7.5 8.98071 7.5 7.6H6.5C6.5 9.533 8.067 11.1 10 11.1V10.1ZM7.5 7.6C7.5 6.21929 8.61929 5.1 10 5.1V4.1C8.067 4.1 6.5 5.667 6.5 7.6H7.5ZM10 5.1C11.3807 5.1 12.5 6.21929 12.5 7.6H13.5C13.5 5.667 11.933 4.1 10 4.1V5.1Z" />
        </svg>
    );
};

export const ClosedEyeIcon = () => {
    return (
        <svg
            className="stroke-current absolute left-0 top-0 h-full w-full"
            width="20"
            height="19"
            viewBox="0 0 20 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="xMidYMid meet"
        >
            <path d="M1 9.4L0.561052 9.16057C0.479649 9.30981 0.479649 9.49019 0.561052 9.63943L1 9.4ZM19 9.4L19.4389 9.63943C19.5204 9.49019 19.5204 9.30981 19.4389 9.16057L19 9.4ZM5.9 9.4C5.9 9.67614 6.12386 9.9 6.4 9.9C6.67614 9.9 6.9 9.67614 6.9 9.4H5.9ZM10 6.3C10.2761 6.3 10.5 6.07614 10.5 5.8C10.5 5.52386 10.2761 5.3 10 5.3V6.3ZM14.1 9.4C14.1 9.12386 13.8761 8.9 13.6 8.9C13.3239 8.9 13.1 9.12386 13.1 9.4H14.1ZM10 12.5C9.72386 12.5 9.5 12.7239 9.5 13C9.5 13.2761 9.72386 13.5 10 13.5V12.5ZM1.24645 17.4464C1.05118 17.6417 1.05118 17.9583 1.24645 18.1536C1.44171 18.3488 1.75829 18.3488 1.95355 18.1536L1.24645 17.4464ZM18.7536 1.35355C18.9488 1.15829 18.9488 0.841709 18.7536 0.646447C18.5583 0.451184 18.2417 0.451184 18.0464 0.646447L18.7536 1.35355ZM1 9.4C1.43895 9.63943 1.43889 9.63954 1.43884 9.63962C1.43884 9.63962 1.43881 9.63968 1.43882 9.63967C1.43883 9.63965 1.43889 9.63953 1.43901 9.63931C1.43925 9.63888 1.43971 9.63805 1.44038 9.63683C1.44172 9.6344 1.44393 9.63041 1.447 9.62492C1.45313 9.61394 1.46269 9.59696 1.47563 9.57437C1.5015 9.52919 1.54086 9.46163 1.59324 9.37488C1.69806 9.20132 1.85482 8.95133 2.05999 8.65042C2.47095 8.04767 3.07281 7.24548 3.83668 6.44524C5.37892 4.82956 7.50562 3.3 10 3.3V2.3C7.09438 2.3 4.72108 4.07044 3.11332 5.75476C2.30219 6.60452 1.66655 7.45233 1.23376 8.08708C1.01705 8.40492 0.85038 8.67056 0.737225 8.85793C0.680629 8.95165 0.637365 9.02588 0.607869 9.07738C0.59312 9.10314 0.581808 9.12322 0.573988 9.13721C0.570078 9.14421 0.567041 9.14969 0.564882 9.1536C0.563803 9.15556 0.562944 9.15712 0.562305 9.15828C0.561986 9.15887 0.561722 9.15935 0.561513 9.15973C0.561409 9.15992 0.561293 9.16013 0.561241 9.16023C0.56114 9.16041 0.561052 9.16057 1 9.4ZM10 3.3C12.4944 3.3 14.6211 4.82956 16.1633 6.44524C16.9272 7.24548 17.529 8.04767 17.94 8.65042C18.1452 8.95133 18.3019 9.20132 18.4068 9.37488C18.4591 9.46163 18.4985 9.52919 18.5244 9.57437C18.5373 9.59696 18.5469 9.61394 18.553 9.62492C18.5561 9.63041 18.5583 9.6344 18.5596 9.63683C18.5603 9.63805 18.5608 9.63888 18.561 9.63931C18.5611 9.63953 18.5612 9.63965 18.5612 9.63967C18.5612 9.63968 18.5612 9.63962 18.5612 9.63962C18.5611 9.63954 18.5611 9.63943 19 9.4C19.4389 9.16057 19.4389 9.16041 19.4388 9.16023C19.4387 9.16013 19.4386 9.15992 19.4385 9.15973C19.4383 9.15935 19.438 9.15887 19.4377 9.15828C19.4371 9.15712 19.4362 9.15556 19.4351 9.1536C19.433 9.14969 19.4299 9.14421 19.426 9.13721C19.4182 9.12322 19.4069 9.10314 19.3921 9.07738C19.3626 9.02588 19.3194 8.95165 19.2628 8.85793C19.1496 8.67056 18.983 8.40492 18.7662 8.08708C18.3335 7.45233 17.6978 6.60452 16.8867 5.75476C15.2789 4.07044 12.9056 2.3 10 2.3V3.3ZM19 9.4C18.5611 9.16057 18.5611 9.16046 18.5612 9.16038C18.5612 9.16038 18.5612 9.16032 18.5612 9.16033C18.5612 9.16035 18.5611 9.16047 18.561 9.16069C18.5608 9.16112 18.5603 9.16195 18.5596 9.16317C18.5583 9.1656 18.5561 9.16959 18.553 9.17508C18.5469 9.18606 18.5373 9.20304 18.5244 9.22563C18.4985 9.27081 18.4591 9.33837 18.4068 9.42512C18.3019 9.59868 18.1452 9.84867 17.94 10.1496C17.529 10.7523 16.9272 11.5545 16.1633 12.3548C14.6211 13.9704 12.4944 15.5 10 15.5V16.5C12.9056 16.5 15.2789 14.7296 16.8867 13.0452C17.6978 12.1955 18.3335 11.3477 18.7662 10.7129C18.983 10.3951 19.1496 10.1294 19.2628 9.94207C19.3194 9.84835 19.3626 9.77412 19.3921 9.72261C19.4069 9.69686 19.4182 9.67678 19.426 9.66279C19.4299 9.65579 19.433 9.65031 19.4351 9.6464C19.4362 9.64444 19.4371 9.64288 19.4377 9.64172C19.438 9.64113 19.4383 9.64065 19.4385 9.64027C19.4386 9.64008 19.4387 9.63987 19.4388 9.63977C19.4389 9.63959 19.4389 9.63943 19 9.4ZM10 15.5C7.50562 15.5 5.37892 13.9704 3.83668 12.3548C3.07281 11.5545 2.47095 10.7523 2.05999 10.1496C1.85482 9.84867 1.69806 9.59868 1.59324 9.42512C1.54086 9.33837 1.5015 9.27081 1.47563 9.22563C1.46269 9.20304 1.45313 9.18606 1.447 9.17508C1.44393 9.16959 1.44172 9.1656 1.44038 9.16317C1.43971 9.16195 1.43925 9.16112 1.43901 9.16069C1.43889 9.16047 1.43883 9.16035 1.43882 9.16033C1.43881 9.16032 1.43884 9.16038 1.43884 9.16038C1.43889 9.16046 1.43895 9.16057 1 9.4C0.561052 9.63943 0.56114 9.63959 0.561241 9.63977C0.561293 9.63987 0.561409 9.64008 0.561513 9.64027C0.561722 9.64065 0.561986 9.64113 0.562305 9.64172C0.562944 9.64288 0.563803 9.64444 0.564882 9.6464C0.567041 9.65031 0.570078 9.65579 0.573988 9.66279C0.581808 9.67678 0.59312 9.69686 0.607869 9.72261C0.637365 9.77412 0.680629 9.84835 0.737225 9.94207C0.85038 10.1294 1.01705 10.3951 1.23376 10.7129C1.66655 11.3477 2.30219 12.1955 3.11332 13.0452C4.72108 14.7296 7.09438 16.5 10 16.5V15.5ZM6.9 9.4C6.9 8.57783 7.22661 7.78933 7.80797 7.20797L7.10086 6.50086C6.33196 7.26976 5.9 8.31261 5.9 9.4H6.9ZM7.80797 7.20797C8.38933 6.62661 9.17783 6.3 10 6.3V5.3C8.91261 5.3 7.86976 5.73196 7.10086 6.50086L7.80797 7.20797ZM13.1 9.4C13.1 10.2222 12.7734 11.0107 12.192 11.592L12.8991 12.2991C13.668 11.5302 14.1 10.4874 14.1 9.4H13.1ZM12.192 11.592C11.6107 12.1734 10.8222 12.5 10 12.5V13.5C11.0874 13.5 12.1302 13.068 12.8991 12.2991L12.192 11.592ZM1.95355 18.1536L18.7536 1.35355L18.0464 0.646447L1.24645 17.4464L1.95355 18.1536Z" />
        </svg>
    );
};

export const GearIcon = () => {
    return (
        <svg
            className="stroke-current absolute left-0 top-0 h-full w-full"
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="xMidYMid meet"
        >
            <path d="M14.25 18.8C16.9009 18.8 19.05 16.6509 19.05 14C19.05 11.349 16.9009 9.19998 14.25 9.19998C11.599 9.19998 9.44998 11.349 9.44998 14C9.44998 16.6509 11.599 18.8 14.25 18.8ZM17.55 14C17.55 15.8225 16.0725 17.3 14.25 17.3C12.4274 17.3 10.95 15.8225 10.95 14C10.95 12.1774 12.4274 10.7 14.25 10.7C16.0725 10.7 17.55 12.1774 17.55 14ZM25.9017 12.1749L25.9178 12.1785L25.934 12.1813C26.1752 12.2232 26.4322 12.3444 26.707 12.5924C26.9138 12.7791 27 12.9784 27 13.2354V14.9229C27 15.1488 26.9263 15.2999 26.748 15.439C26.4627 15.6618 26.1737 15.8053 25.8795 15.883L23.6983 16.4086L23.294 16.506L23.1625 16.9005C23.0793 17.15 22.9926 17.3852 22.9026 17.6062C22.8161 17.8184 22.7177 18.0271 22.6072 18.2323L22.4059 18.6062L22.6229 18.9712L23.7831 20.9224L23.7907 20.9352L23.7989 20.9478C23.9583 21.193 24.0638 21.4846 24.1045 21.8379C24.1302 22.0606 24.0745 22.231 23.8974 22.4081L22.7109 23.5947C22.5289 23.7767 22.333 23.8522 22.0699 23.8376C21.7083 23.8175 21.4255 23.7233 21.1978 23.5753L21.1978 23.5752L21.1929 23.5721L19.2944 22.3592L18.9358 22.1301L18.5552 22.3204C18.3219 22.437 18.0891 22.5451 17.8569 22.6446C17.6365 22.7391 17.3969 22.8271 17.1376 22.9082L16.7209 23.0384L16.6284 23.4651L16.1538 25.6535L16.1505 25.6687L16.1478 25.684C16.1059 25.9252 15.9847 26.1822 15.7367 26.457C15.55 26.6638 15.3507 26.75 15.0938 26.75H13.4062C13.1803 26.75 13.0292 26.6763 12.8901 26.498C12.6671 26.2124 12.5235 25.9231 12.4459 25.6286L11.92 23.4727L11.8196 23.0609L11.4151 22.9345C11.1543 22.853 10.8925 22.759 10.6299 22.6523C10.3724 22.5477 10.1236 22.4313 9.88321 22.3031L9.49733 22.0973L9.12817 22.3317L7.177 23.571L7.16617 23.5779L7.15559 23.5851C6.95533 23.7221 6.68562 23.8172 6.31218 23.8375C6.0355 23.8526 5.85394 23.774 5.69778 23.6092L5.68798 23.5988L5.67779 23.5889L4.47643 22.4136C4.31905 22.2436 4.26315 22.0704 4.28998 21.8379C4.33194 21.4743 4.43375 21.1748 4.58319 20.9255C4.58331 20.9253 4.58343 20.9251 4.58355 20.9249L5.82208 18.8695L6.03504 18.5161L5.85051 18.147C5.75063 17.9473 5.65477 17.7431 5.56295 17.5344C5.48086 17.3478 5.40869 17.1471 5.34712 16.9317L5.22694 16.511L4.80167 16.4086L2.62053 15.883C2.32629 15.8053 2.03734 15.6618 1.75198 15.439C1.57369 15.2999 1.5 15.1488 1.5 14.9229V13.2354C1.5 12.9784 1.58615 12.7791 1.793 12.5924C2.06782 12.3444 2.32478 12.2232 2.56601 12.1813L2.58223 12.1785L2.59831 12.1749L4.76041 11.7003L5.19775 11.6043L5.32075 11.1738C5.38198 10.9595 5.45907 10.7433 5.55264 10.5249C5.65557 10.2848 5.75825 10.0538 5.86066 9.83187L6.02723 9.47096L5.82208 9.1305L4.58355 7.07507C4.58343 7.07487 4.58332 7.07468 4.5832 7.07449C4.43375 6.8252 4.33194 6.52574 4.28998 6.16208C4.26315 5.92955 4.31905 5.75639 4.47643 5.58637L5.67779 4.41113L5.68798 4.40116L5.69778 4.39081C5.85394 4.22598 6.0355 4.14737 6.31218 4.16246C6.68562 4.18283 6.95533 4.27786 7.15559 4.41488L7.16617 4.42212L7.177 4.429L9.12817 5.66825L9.49733 5.90272L9.88321 5.69692C10.1266 5.5671 10.3737 5.44965 10.6245 5.34448C10.8753 5.2393 11.13 5.14632 11.3887 5.06547L11.7879 4.94075L11.8916 4.53568L12.4453 2.37357L12.4487 2.36025L12.4516 2.34682C12.5132 2.0637 12.6444 1.78295 12.8637 1.50198C12.9966 1.33169 13.1523 1.25 13.4062 1.25H15.0938C15.35 1.25 15.541 1.33526 15.7167 1.53538C15.9664 1.81981 16.0989 2.08256 16.1545 2.32336L16.628 4.53312L16.7177 4.95202L17.1242 5.08749C17.3712 5.16984 17.6139 5.26036 17.8524 5.35903C18.0908 5.4577 18.3251 5.56455 18.5552 5.67961L18.9358 5.86991L19.2944 5.64081L21.1929 4.42792L21.1929 4.42794L21.1978 4.42473C21.4255 4.2767 21.7083 4.18251 22.0699 4.16242C22.333 4.1478 22.5289 4.22332 22.7109 4.40533L23.8974 5.59185C24.0745 5.76897 24.1302 5.93945 24.1045 6.16208C24.0638 6.51536 23.9583 6.80696 23.7989 7.0522L23.7907 7.06475L23.7831 7.07763L22.6229 9.0288L22.4135 9.38101L22.5968 9.74752C22.715 9.98403 22.8291 10.225 22.9392 10.4704C23.0347 10.6835 23.1128 10.9096 23.1728 11.1497L23.2855 11.6007L23.7396 11.7003L25.9017 12.1749Z" />
        </svg>
    );
};

export const Logo = () => {
    return (
        <svg
            className="absolute left-0 top-0 h-full w-full fill-current"
            width="240"
            height="43"
            viewBox="0 0 240 43"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="xMidYMid meet"
        >
            <path d="M21.7247 42.9995C33.7229 42.9995 43.4494 33.3738 43.4494 21.4998C43.4494 9.62577 33.7229 0 21.7247 0C9.72649 0 0 9.62577 0 21.4998C0 33.3738 9.72649 42.9995 21.7247 42.9995Z" />
            <path d="M56.4494 1.39041H70.2204L78.7282 32.0933C78.9985 33.3808 79.1181 34.6949 79.0845 36.0095C79.0845 36.1965 79.1595 36.3758 79.2931 36.508C79.4267 36.6402 79.6078 36.7145 79.7968 36.7145C79.9857 36.7145 80.1668 36.6402 80.3004 36.508C80.434 36.3758 80.509 36.1965 80.509 36.0095C80.4537 34.6943 80.5735 33.3776 80.8653 32.0933L89.3727 1.39041H103.144V42.0034H95.2295V11.5726C95.2828 9.91056 95.6172 8.26914 96.2189 6.71654C96.3774 6.20757 96.2189 5.85499 95.7046 5.73746C95.5433 5.72017 95.3813 5.76262 95.2498 5.85662C95.1183 5.95061 95.0266 6.08948 94.9925 6.24643L84.745 41.9617H74.9294L64.6819 6.24597C64.5632 5.85453 64.2864 5.65833 63.9699 5.737C63.8592 5.74672 63.7527 5.78388 63.6604 5.84506C63.5681 5.90624 63.4928 5.98946 63.4415 6.08703C63.3903 6.1846 63.3647 6.29337 63.3672 6.40332C63.3696 6.51326 63.4 6.62082 63.4556 6.71606C64.0572 8.26866 64.3916 9.91008 64.4449 11.5721V42.0034H56.5284V1.39041H56.4494Z" />
            <path d="M108.486 29.5863V11.5721H115.964V27.041C115.964 33.8945 117.784 35.8134 121.663 35.8134C125.976 35.8134 129.933 31.0355 129.933 23.9863V11.5721H137.412V42.0399H129.934V40.1211C129.912 38.6822 130.237 37.2589 130.883 35.9697C131.123 35.4608 131.477 34.6381 130.725 34.4817C130.25 34.3642 130.092 34.7186 129.854 35.1864C128.351 38.2018 124.947 42.5095 119.607 42.5095C112.918 42.51 108.486 38.2411 108.486 29.5863Z" />
            <path d="M171.8 24.0256V42.0399H164.322V26.5714C164.322 19.7179 162.502 17.7991 158.623 17.7991C154.31 17.7991 150.353 22.5769 150.353 29.6262V42.0422H142.874V11.5726H150.353V13.4914C150.395 14.9322 150.068 16.3601 149.403 17.6427C149.164 18.1517 148.81 18.9744 149.562 19.1308C150.037 19.2483 150.195 18.8938 150.432 18.4261C151.817 15.3713 155.339 11.1029 160.68 11.1029C167.369 11.1025 171.8 15.3708 171.8 24.0256Z" />
            <path d="M205.792 0.489532V42.0399H198.313V40.7082C198.317 39.611 198.603 38.5328 199.144 37.5753C199.421 36.9877 199.658 36.438 199.025 36.2048C198.511 36.0479 198.274 36.5962 198.155 36.7924C195.978 39.9647 193.089 42.51 188.42 42.51C180.427 42.51 175.005 35.5783 175.005 26.806C175.005 18.0337 180.427 11.102 188.42 11.102C193.209 11.102 196.453 13.4127 198.155 16.7414C198.274 16.9783 198.63 17.7204 199.223 17.446C199.816 17.1717 199.463 16.467 199.183 15.8793C198.65 14.9044 198.365 13.8156 198.353 12.7071V0.489532H205.792ZM198.313 26.806C198.313 21.95 195.028 17.7986 190.161 17.7986C184.898 17.7986 182.445 21.95 182.445 26.806C182.445 31.662 184.899 35.8134 190.161 35.8134C195.029 35.8134 198.313 31.6625 198.313 26.806H198.313Z" />
            <path d="M210.739 29.5863V11.5721H218.218V27.041C218.218 33.8945 220.037 35.8134 223.916 35.8134C228.23 35.8134 232.187 31.0355 232.187 23.9863V11.5721H239.666V42.0399H232.187V40.1211C232.164 38.6822 232.49 37.2589 233.136 35.9697C233.376 35.4608 233.73 34.6381 232.978 34.4817C232.503 34.3642 232.345 34.7186 232.107 35.1864C230.603 38.2018 227.2 42.5095 221.86 42.5095C215.17 42.51 210.739 38.2411 210.739 29.5863Z" />
        </svg>
    );
};
export const MusicIcon = () => {
    return (
        <svg
            className="fill-current absolute left-0 top-0 h-full w-full "
            stroke="none"
            width="18"
            height="24"
            viewBox="0 0 18 24"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="xMidYMid meet"
        >
            <path d="M17.4475 0.0125152L5.85349 2.26233C5.73686 2.27215 5.62739 2.32265 5.54422 2.40501C5.46106 2.48737 5.40949 2.59635 5.39854 2.71288V16.2147C5.40206 16.4411 5.35597 16.6655 5.26352 16.8722C5.1673 17.0452 5.03773 17.1975 4.88231 17.3202C4.72689 17.4429 4.54869 17.5335 4.35802 17.5869C4.1731 17.6486 3.91774 17.7043 3.62422 17.7718C2.26964 18.0756 0.00221057 18.5922 0.00221057 20.685C-0.0252219 21.3468 0.20352 21.9937 0.640862 22.4912C1.0782 22.9887 1.69048 23.2984 2.35036 23.356C2.48227 23.3789 2.61569 23.3922 2.74954 23.3956C3.75172 23.359 4.73406 23.1057 5.62895 22.653C6.06952 22.3619 6.4263 21.9605 6.66391 21.4889C6.90153 21.0173 7.01171 20.4918 6.98354 19.9644V8.01382C6.98178 7.90978 7.01693 7.80847 7.08275 7.72788C7.14857 7.64728 7.2408 7.5926 7.3431 7.57354L15.8845 5.84912C15.9498 5.8356 16.0174 5.83682 16.0822 5.85268C16.147 5.86854 16.2075 5.89865 16.2592 5.94082C16.311 5.98298 16.3526 6.03615 16.3812 6.09645C16.4098 6.15675 16.4246 6.22266 16.4246 6.2894V13.6508C16.4368 13.9099 16.3865 14.1682 16.2778 14.4037C16.1811 14.5775 16.0507 14.7302 15.8942 14.853C15.7377 14.9757 15.5583 15.066 15.3664 15.1184C15.1815 15.1801 14.8718 15.2358 14.5739 15.3033C13.2193 15.6071 10.9519 16.1193 10.9519 18.2106C10.9135 18.8798 11.1371 19.5377 11.5754 20.0448C12.0138 20.5519 12.6323 20.8684 13.3001 20.9272C13.6642 20.9534 14.0302 20.9367 14.3905 20.8773C15.1121 20.7512 15.8069 20.503 16.4451 20.1435C16.9295 19.8802 17.3308 19.487 17.6041 19.0082C17.8773 18.5293 18.0117 17.9838 17.9919 17.4328V0.445455C17.9927 0.378336 17.9782 0.311926 17.9494 0.251301C17.9205 0.190676 17.8782 0.13744 17.8257 0.0956646C17.7732 0.0538889 17.7118 0.0246787 17.6462 0.0102674C17.5807 -0.00414392 17.5127 -0.00337521 17.4475 0.0125152Z" />
        </svg>
    );
};

export const MessageIcon = () => {
    return (
        <svg
            className="stroke-current stroke-2 absolute left-0 top-0  h-full w-full"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="xMidYMid meet"
        >
            <path
                d="M4.5 5H19.5C20.8807 5 22 6.11929 22 7.5V14.5C22 15.8807 20.8807 17 19.5 17H14.5L10 20.5V17H4.5C3.11929 17 2 15.8807 2 14.5V7.5C2 6.11929 3.11929 5 4.5 5Z"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const EnvelopeIcon = () => {
    return (
        <svg
            className="stroke-current stroke-1 absolute left-0 top-0  h-full w-full"
            width="29"
            height="20"
            viewBox="0 0 29 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="xMidYMid meet"
        >
            <path
                d="M1 1H28M1 1V19M1 1L12.6582 10.0675C13.7415 10.9101 15.2585 10.9101 16.3418 10.0675L28 1M28 1V19M28 19H1M28 19L17.849 8.89525M1 19L11.151 8.89525"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const SearchIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className="stroke-current stroke-2 absolute left-0 top-0  h-full w-full"
            fill="none"
            viewBox="0 0 24 24"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            />
        </svg>
    );
};
export const HamburgerIcon = () => {
    return (
        <svg
            className="stroke-current stroke-2 absolute left-0 top-0  h-full w-full"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16M4 18h16"
            />
        </svg>
    );
};
export const CloseIcon = () => {
    return (
        <svg
            className="stroke-current absolute left-0 top-0  h-full w-full"
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 24 24"
        >
            <line
                id="Line_1277"
                data-name="Line 1277"
                x2="24"
                y2="24"
                fill="none"
                strokeWidth="3"
            />
            <line
                id="Line_1278"
                data-name="Line 1278"
                x2="24"
                y2="24"
                transform="translate(24 0) rotate(90)"
                fill="none"
                strokeWidth="3"
            />
        </svg>
    );
};

export const CheckMark = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className="stroke-current stroke-2 absolute left-0 top-0 h-full w-full"
            fill="none"
            viewBox="0 0 24 24"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
            />
        </svg>
    );
};

export const UserIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        className="absolute left-0 top-0 h-full w-full"
        viewBox="0 0 20 20"
        fill="currentColor"
    >
        <path
            fillRule="evenodd"
            d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
            clipRule="evenodd"
        />
    </svg>
);

export const Film = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className="stroke-current absolute left-0 top-0 h-full w-full"
            fill="none"
            viewBox="0 0 24 24"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M7 4v16M17 4v16M3 8h4m10 0h4M3 12h18M3 16h4m10 0h4M4 20h16a1 1 0 001-1V5a1 1 0 00-1-1H4a1 1 0 00-1 1v14a1 1 0 001 1z"
            />
        </svg>
    );
};

export const VideoIcon = () => {
    return (
        <svg
            className=" absolute left-0 h-full w-full scale-150 fill-current"
            viewBox="0 0 36 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask id="Mask">
                <path d="M0 6C0 2.68629 2.68629 0 6 0H30C33.3137 0 36 2.68629 36 6V18C36 21.3137 33.3137 24 30 24H6C2.68629 24 0 21.3137 0 18V6Z" />
                <path
                    fill="black"
                    d="M23.25 12.375L15.9375 16.5969V8.15313L23.25 12.375Z"
                />
            </mask>
            <path
                mask="url(#Mask)"
                d="M0 6C0 2.68629 2.68629 0 6 0H30C33.3137 0 36 2.68629 36 6V18C36 21.3137 33.3137 24 30 24H6C2.68629 24 0 21.3137 0 18V6Z"
            />
        </svg>
    );
};

export const PlusIcon = () => {
    return (
        <svg
            viewBox="0 0 18 18"
            className="absolute left-0 top-0 h-full w-full"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M8.21892 0V18H9.61892V0H8.21892ZM18 8.38108L2.40566e-08 8.38108L-2.40566e-08 9.78108H18V8.38108Z"
                className="fill-current"
            />
        </svg>
    );
};

export const TitleIcon = () => {
    return (
        <svg
            className="absolute left-0 top-0 h-full w-full fill-current"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 14.62 14.62"
        >
            <path
                id="Icon_open-text"
                data-name="Icon open-text"
                d="M0,0V3.655H.914A1.833,1.833,0,0,1,2.741,1.828H5.483V11.879a.9.9,0,0,1-.914.914H3.655V14.62h7.31V12.792h-.914a.9.9,0,0,1-.914-.914V1.828h2.741a1.833,1.833,0,0,1,1.827,1.828h.914V0Z"
            />
        </svg>
    );
};

export const ArrowRightIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className="absolute left-0 top-0 h-full w-full scale-125 "
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={1}
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M17 8l4 4m0 0l-4 4m4-4H3"
            />
        </svg>
    );
};

export const ArrowLeftIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className="absolute left-0 top-0 h-full w-full scale-125"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={1}
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M7 16l-4-4m0 0l4-4m-4 4h18"
            />
        </svg>
    );
};

export const ClockIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className="absolute left-0 top-0 h-full w-full stroke-current"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
            />
        </svg>
    );
};

export const CalendarIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className="absolute left-0 top-0 h-full w-full stroke-current"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
            />
        </svg>
    );
};

export const HeartIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className="absolute top-0 h-full w-full stroke-current"
            viewBox="0 0 24 24"
            fill="none"
            strokeWidth={2}
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
            />
        </svg>
    );
};

export const RecordCollectionIcon = () => {
    return (
        <svg
            className="absolute top-0 h-full w-full stroke-current"
            width="47"
            height="56"
            viewBox="0 0 47 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M26 3L46 20V43L26 27V3Z" fill="#C4C4C4" stroke="black" />
            <path
                d="M1 14.3333L26 3V27.6667L1 39V14.3333Z"
                fill="#C4C4C4"
                stroke="black"
                strokeWidth="0.5"
            />
            <path
                d="M3 10.8135C3 10.4117 3.24044 10.049 3.61046 9.89249L25.6105 0.587698C26.2698 0.30884 27 0.79284 27 1.50871V27.1444C27 27.5327 26.7752 27.8859 26.4235 28.0503L4.42348 38.3346C3.76044 38.6445 3 38.1606 3 37.4287V10.8135Z"
                fill="#FFF3EB"
                stroke="#4B2F3E"
                strokeWidth="0.5"
            />
            <path
                d="M6 12.8135C6 12.4117 6.24044 12.049 6.61046 11.8925L28.6105 2.5877C29.2698 2.30884 30 2.79284 30 3.50871V29.1444C30 29.5327 29.7752 29.8859 29.4235 30.0503L7.42348 40.3346C6.76044 40.6445 6 40.1606 6 39.4287V12.8135Z"
                fill="#FFF3EB"
                stroke="#4B2F3E"
                strokeWidth="0.5"
            />
            <path
                d="M6 12.8135C6 12.4117 6.24044 12.049 6.61046 11.8925L28.6105 2.5877C29.2698 2.30884 30 2.79284 30 3.50871V29.1444C30 29.5327 29.7752 29.8859 29.4235 30.0503L7.42348 40.3346C6.76044 40.6445 6 40.1606 6 39.4287V12.8135Z"
                fill="#FFF3EB"
                stroke="#4B2F3E"
                strokeWidth="0.5"
            />
            <path
                d="M9 14.8135C9 14.4117 9.24044 14.049 9.61046 13.8925L31.6105 4.5877C32.2698 4.30884 33 4.79284 33 5.50871V31.1444C33 31.5327 32.7752 31.8859 32.4235 32.0503L10.4235 42.3346C9.76044 42.6445 9 42.1606 9 41.4287V14.8135Z"
                fill="#FFF3EB"
                stroke="#4B2F3E"
                strokeWidth="0.5"
            />
            <path
                d="M12 16.8135C12 16.4117 12.2404 16.049 12.6105 15.8925L34.6105 6.5877C35.2698 6.30884 36 6.79284 36 7.50871V33.1444C36 33.5327 35.7752 33.8859 35.4235 34.0503L13.4235 44.3346C12.7604 44.6445 12 44.1606 12 43.4287V16.8135Z"
                fill="#FFF3EB"
                stroke="#4B2F3E"
                strokeWidth="0.5"
            />
            <path
                d="M15 19.8135C15 19.4117 15.2404 19.049 15.6105 18.8925L37.6105 9.5877C38.2698 9.30884 39 9.79284 39 10.5087V36.1444C39 36.5327 38.7752 36.8859 38.4235 37.0503L16.4235 47.3346C15.7604 47.6445 15 47.1606 15 46.4287V19.8135Z"
                fill="#FFF3EB"
                stroke="#4B2F3E"
                strokeWidth="0.5"
            />
            <path
                d="M18 21.8135C18 21.4117 18.2404 21.049 18.6105 20.8925L40.6105 11.5877C41.2698 11.3088 42 11.7928 42 12.5087V38.1444C42 38.5327 41.7752 38.8859 41.4235 39.0503L19.4235 49.3346C18.7604 49.6445 18 49.1606 18 48.4287V21.8135Z"
                fill="#FFF3EB"
                stroke="#4B2F3E"
                strokeWidth="0.5"
            />
            <path
                d="M21 30.3333L46 20V43.6666L21 55V30.3333Z"
                fill="#FFF3EB"
                stroke="black"
                strokeWidth="0.5"
            />
            <path
                d="M30 29.8381L39 26V28.5L30 32.6619V29.8381Z"
                fill="#4B2F3E"
                stroke="black"
                strokeWidth="0.5"
            />
            <path
                d="M1 14.5L21 30.5V55L1 39.5V14.5Z"
                fill="#FFF3EB"
                stroke="black"
                strokeWidth="0.5"
            />
        </svg>
    );
};

export const ArtistIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className="absolute top-0 h-full w-full stroke-current"
            fill="none"
            viewBox="0 0 24 24"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z"
            />
        </svg>
    );
};

export const CdIcon = () => {
    return (
        <svg
            className="absolute top-0 h-full w-full stroke-current"
            stroke="currentColor"
            fill="currentColor"
            strokeWidth="0"
            viewBox="0 0 16 16"
            height="1em"
            width="1em"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-6 0a2 2 0 1 0-4 0 2 2 0 0 0 4 0zM4 8a4 4 0 0 1 4-4 .5.5 0 0 0 0-1 5 5 0 0 0-5 5 .5.5 0 0 0 1 0zm9 0a.5.5 0 1 0-1 0 4 4 0 0 1-4 4 .5.5 0 0 0 0 1 5 5 0 0 0 5-5z"></path>
        </svg>
    );
};

export const BackIcon = () => {
    return (
        <svg
            className="absolute top-0 h-full w-full stroke-current"
            viewBox="0 0 100 100"
        >
            <line
                x1="22"
                y1="50"
                x2="72"
                y2="0"
                strokeWidth="10"
                strokeLinecap="round"
            />
            <line
                x1="22"
                y1="50"
                x2="72"
                y2="100"
                strokeWidth="10"
                strokeLinecap="round"
            />
        </svg>
    );
};

export const ForwardIcon = () => {
    return (
        <svg
            className="absolute top-0 h-full w-full stroke-current"
            viewBox="0 0 100 100"
        >
            <line
                x1="28"
                y1="0"
                x2="78"
                y2="50"
                strokeWidth="10"
                strokeLinecap="round"
            />
            <line
                x1="28"
                y1="100"
                x2="78"
                y2="50"
                strokeWidth="10"
                strokeLinecap="round"
            />
        </svg>
    );
};

export const QuestionMarkIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        className="absolute top-0 h-full w-full fill-current"
        viewBox="0 0 20 20"
        fill="currentColor"
    >
        <path
            fillRule="evenodd"
            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z"
            clipRule="evenodd"
        />
    </svg>
);

export const UploadIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        className="absolute top-0 h-full w-full fill-current"
        viewBox="0 0 24 24"
    >
        <path d="M14,13V17H10V13H7L12,8L17,13M19.35,10.03C18.67,6.59 15.64,4 12,4C9.11,4 6.6,5.64 5.35,8.03C2.34,8.36 0,10.9 0,14A6,6 0 0,0 6,20H19A5,5 0 0,0 24,15C24,12.36 21.95,10.22 19.35,10.03Z" />
    </svg>
);

export const CopyIcon = ({ className }: { className?: string }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={1.8}
    >
        <rect x="9" y="9" width="12" height="12" rx="2" />
        <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"
        />
    </svg>
);

export const ForbiddenIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        className="absolute top-0 h-full w-full stroke-current"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={2}
    >
        <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"
        />
    </svg>
);

export const ImagesIcon = () => (
    <svg
        className="absolute top-0 h-full w-full stroke-current"
        viewBox="0 0 512 512"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill="none"
            strokeLinejoin="round"
            strokeWidth="32"
            d="M432 112V96a48.14 48.14 0 00-48-48H64a48.14 48.14 0 00-48 48v256a48.14 48.14 0 0048 48h16"
        />
        <rect
            width="400"
            height="336"
            x="96"
            y="128"
            fill="none"
            strokeLinejoin="round"
            strokeWidth="32"
            rx="45.99"
            ry="45.99"
        />
        <ellipse
            cx="372.92"
            cy="219.64"
            fill="none"
            strokeMiterlimit="10"
            strokeWidth="32"
            rx="30.77"
            ry="30.55"
        />
        <path
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="32"
            d="M342.15 372.17L255 285.78a30.93 30.93 0 00-42.18-1.21L96 387.64M265.23 464l118.59-117.73a31 31 0 0141.46-1.87L496 402.91"
        />
    </svg>
);
export const LoopIcon = () => (
    <svg
        className="absolute top-0 h-full w-full stroke-current fill-current"
        xmlns="http://www.w3.org/2000/svg"
        width="107.431"
        height="99.975"
        viewBox="0 0 107.431 99.975"
    >
        <g id="loop" transform="translate(2.375 -6.691)">
            <path
                id="Path_14"
                data-name="Path 14"
                d="M96.838,19.41V30.872a24.029,24.029,0,0,1-24,24H14.252L23.828,45.3l-4.849-4.849L9.406,50.025l-.945.945L1.268,58.163,17.132,76.007l5.126-4.556-8.647-9.719H72.837A30.887,30.887,0,0,0,103.7,30.872V12.552Z"
                transform="translate(-2.143 29.158)"
                strokeLinejoin="round"
                strokeWidth="3"
            />
            <path
                id="Path_15"
                data-name="Path 15"
                d="M7.983,48.326a24.029,24.029,0,0,1,24-24H90.569L80.993,33.9l4.849,4.849,9.576-9.576.881-.881,7.257-7.257L87.692,3.191,82.566,7.747l8.644,9.719H31.984A30.894,30.894,0,0,0,1.125,48.326V66.71l6.858-6.858Z"
                transform="translate(0 5)"
                strokeLinejoin="round"
                strokeWidth="3"
            />
        </g>
    </svg>
);

export const GroupIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        className="absolute top-0 h-full w-full stroke-current"
        viewBox="0 0 24 24"
        fill="none"
    >
        <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
        />
    </svg>
);

export const ModulesIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        className="absolute top-0 h-full w-full stroke-current"
        viewBox="0 0 24 24"
        fill="none"
    >
        <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.8"
            d="M4 5.5A1.5 1.5 0 015.5 4h3.75a1.5 1.5 0 011.5 1.5v3.75a1.5 1.5 0 01-1.5 1.5H5.5A1.5 1.5 0 014 9.25V5.5zM13.25 5.5A1.5 1.5 0 0114.75 4h3.75A1.5 1.5 0 0120 5.5v3.75a1.5 1.5 0 01-1.5 1.5h-3.75a1.5 1.5 0 01-1.5-1.5V5.5zM4 14.75a1.5 1.5 0 011.5-1.5h3.75a1.5 1.5 0 011.5 1.5v3.75a1.5 1.5 0 01-1.5 1.5H5.5a1.5 1.5 0 01-1.5-1.5v-3.75zM13.25 14.75a1.5 1.5 0 011.5-1.5h3.75a1.5 1.5 0 011.5 1.5v3.75a1.5 1.5 0 01-1.5 1.5h-3.75a1.5 1.5 0 01-1.5-1.5v-3.75z"
        />
    </svg>
);

export const DesktopIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        className="absolute top-0 h-full w-full stroke-current"
        fill="none"
        viewBox="0 0 24 24"
    >
        <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
        />
    </svg>
);
